(function(){
    angular
        .module('appback')
        .directive('ngUrianalisisnew', urianalisis);

        urianalisis.$inject = ['GenerallabService','ResultadosService','$timeout'];
        function urianalisis(GenerallabService,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=urianalisisnew.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.generalLab = GenerallabService;
		            	if(!scope.item.resultado.extra){
		            		scope.item.resultado = { extra : { comentarios: [],resultado : { cristales:[{}], cilindros:[{}] }}};
		            		//console.log(scope.item.resultado.extra);
			            }else{
		            		//console.log("aki2");
		            		if(!scope.item.resultado.extra.comentarios){
			            		scope.item.resultado.extra.comentarios = [];
			            	}
			            	if(!scope.item.resultado.extra.resultado.cristales){
			            		scope.item.resultado.extra.resultado.cristales = [{}];
			            	}else{
			            		//SI NO EXISTE LE AÑADIMOS COMO OBJETO
			            		for(var cont = 0;cont<scope.item.resultado.extra.resultado.cristales.length;cont++){
			            			if(typeof(scope.item.resultado.extra.resultado.cristales[cont].cristal)=='undefined' && typeof(scope.item.resultado.extra.resultado.cristales[cont].resultado)=='undefined'){
			            				scope.item.resultado.extra.resultado.cristales[cont] = {};
			            			}
			            		}
			            		//scope.item.resultado.extra.resultado.cristales = JSON.parse(angular.toJson(scope.item.resultado.extra.resultado.cristales))
			            		//console.log(JSON.parse(angular.toJson(scope.item.resultado.extra.resultado.cristales)));

			            	}
			            	if(!scope.item.resultado.extra.resultado.cilindros){
			            		scope.item.resultado.extra.resultado.cilindros = [{}];
			            	}else{
			            		//SI NO EXISTE LE AÑADIMOS COMO OBJETO
			            		for(var cont = 0;cont<scope.item.resultado.extra.resultado.cilindros.length;cont++){
			            			if(typeof(scope.item.resultado.extra.resultado.cilindros[cont].cilindro)=='undefined' && typeof(scope.item.resultado.extra.resultado.cilindros[cont].resultado)=='undefined'){
			            				scope.item.resultado.extra.resultado.cilindros[cont] = {};
			            			}
			            		}
			            		//scope.item.resultado.extra.resultado.cristales = JSON.parse(angular.toJson(scope.item.resultado.extra.resultado.cristales))
			            		//console.log(JSON.parse(angular.toJson(scope.item.resultado.extra.resultado.cristales)));

			            	}
			            }
			            //console.log(scope.item.resultado);
		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                      }

	                      scope.resultadoSub = function(codigo_alfa,valor){
	                      	if(typeof(scope.item.resultado.extra.resultado.subanalitica)=='undefined'){
	                      		scope.item.resultado.extra.resultado.subanalitica = {};
	                      	}
	                      	if(typeof(scope.item.resultado.extra.resultado.subanalitica[codigo_alfa])=='undefined'){
	                      		scope.item.resultado.extra.resultado.subanalitica[codigo_alfa] = { resultado : '' };
	                      	}
	                      	scope.item.resultado.extra.resultado.subanalitica[codigo_alfa].resultado = valor;
	                      }

	                      scope.resultadoIdSub = function(codigo_alfa,valor){
	                      	if(typeof(scope.item.resultado.extra.resultado.subanalitica)=='undefined'){
	                      		scope.item.resultado.extra.resultado.subanalitica = {};
	                      	}
	                      	if(typeof(scope.item.resultado.extra.resultado.subanalitica[codigo_alfa])=='undefined'){
	                      		scope.item.resultado.extra.resultado.subanalitica[codigo_alfa] = { resultado_id : '' };
	                      	}
	                      	scope.item.resultado.extra.resultado.subanalitica[codigo_alfa].resultado_id = valor;
	                      }
		            	scope.loading = true;
		            	//console.log(scope);
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			               scope.subanaliticas = data.subanaliticas;
                    		scope.loading = false;
			            });
			            scope.borrarCristal = function(i){
			            	scope.item.resultado.extra.resultado.cristales.splice(i,1);
			            }
			            scope.nuevoCristal = function(){
			            	scope.item.resultado.extra.resultado.cristales.push({});
			            }

			            scope.borrarCilindro = function(i){
			            	scope.item.resultado.extra.resultado.cilindros.splice(i,1);
			            }
			            scope.nuevoCilindro = function(){
			            	scope.item.resultado.extra.resultado.cilindros.push({});
			            }

			            scope.borrarComentario = function(index){
			            	scope.item.resultado.extra.comentarios.splice(index,1);
			            }

			            scope.formatDate = function(date)
					    {
					       var hours = date.getHours();
						  var minutes = date.getMinutes();
						  var ampm = hours >= 12 ? 'pm' : 'am';
						  hours = hours % 12;
						  hours = hours ? hours : 12; // the hour '0' should be '12'
						  minutes = minutes < 10 ? '0'+minutes : minutes;
						  var strTime = hours + ':' + minutes + ' ' + ampm;
						  return date.getDate() + "/" +(date.getMonth()+1) + "/" + date.getFullYear() + "  " + strTime;

					    }


			            scope.nuevoComentario = function(){
			            	scope.item.resultado.extra.comentarios.push({fecha:scope.formatDate(new Date())});
			            }

			            scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
			        });
		        }
          }
      }
})();